import {createReducer, on} from '@ngrx/store';
import {reset, setCulture, setProfile, setUserId} from './userProfile.actions';
import {Cultures} from '../../shared/models/settings/cultures';
import {userProfileInitialState} from "./userProfile.state";



// Migration function to handle old state format
const migrateUserProfileState = (state: any) => {
  // Check if state is in old format (has userId directly on state)
  if (state.userId && !state.profile) {
    return {
      ...userProfileInitialState,
      profile: {
        userId: state.userId || '',
        cultureCode: state.cultureCode || '',
        language: state.language || '',
        isAuthenticated: state.isAuthenticated || false,
        generalInformation: state.generalInformation || null,
        medicalBackground: state.medicalBackground || null,
        healthcareProvider: state.healthcareProvider || null,
      }
    };
  }

  // If already in new format or empty, return as-is
  return state;
};

export const userProfileReducer = createReducer(
  userProfileInitialState,

  // Add migration check to each action
  on(setUserId, (state, action) => {
    const migratedState = migrateUserProfileState(state);
    return {
      ...migratedState,
      profile: {
        ...migratedState.profile,
        userId: action.userId,
      }
    };
  }),

  on(setCulture, (state, action) => {
    const migratedState = migrateUserProfileState(state);
    return {
      ...migratedState,
      profile: {
        ...migratedState.profile,
        cultureCode: action.cultureCode,
        language: getUserLanguage(action.cultureCode)
      }
    };
  }),

  on(setProfile, (state, action) => {
    const migratedState = migrateUserProfileState(state);
    return {
      ...migratedState,
      profile: {
        ...action.profile,
        userId: action.profile.userId || migratedState.profile?.userId || '',
        cultureCode: action.profile.cultureCode || migratedState.profile?.cultureCode || '',
        language: action.profile.language || migratedState.profile?.language || '',
        isAuthenticated: action.profile.isAuthenticated || migratedState.profile?.isAuthenticated || false,
        generalInformation: action.profile.generalInformation || migratedState.profile?.generalInformation || null,
        medicalBackground: action.profile.medicalBackground || migratedState.profile?.medicalBackground || null,
        healthcareProvider: action.profile.healthcareProvider || migratedState.profile?.healthcareProvider || null,
      }
    };
  }),

  on(reset, (state) => ({
    ...userProfileInitialState
  }))
);

function getUserLanguage(cultureCode:string) {
  let langToSet;
  if (cultureCode) {
    switch (cultureCode) {
      case Cultures.fr_fr:
        langToSet = 'fr';
        break;
      case Cultures.nl_nl:
      case Cultures.nl_be:
        langToSet = 'nl';
        break;
      case Cultures.en_us:
        langToSet = 'en';
        break;
    }
  }
  return langToSet;
}
